import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Modal } from 'synfrastructure';
import { SubmissionError } from 'redux-form';

import { formatValidationErrors } from '../../common/utils/getApiReducer';
import { addShow } from '../actions';

import Icon from '../../common/icons/Icon';
import AddForm from '../../common/forms/AddForm';
import Loading from '../../common/components/Loading';

class TvShowListPage extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    shows: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      addShowModalVisible: false,
    };
  }

  toggleAddShowModal = () => {
    this.setState({ addShowModalVisible: !this.state.addShowModalVisible });
  };

  onAddShowSubmit = values => {
    const { dispatch } = this.props;

    return dispatch(addShow(values)).then(action => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        this.props.history.push(`/tv/shows/${action.json.id}`);
      }
    });
  };

  render() {
    const { addShowModalVisible } = this.state;
    const { shows } = this.props;

    if (!this.props.shows.get('loaded')) {
      return <Loading />;
    }

    return (
      <div className="admin-paper">
        <Modal isVisible={addShowModalVisible} onClose={this.toggleAddShowModal}>
          <AddForm
            entityType="Show"
            initialValues={{ name: null }}
            onSubmit={this.onAddShowSubmit}
            onCancel={this.toggleAddShowModal}
          />
        </Modal>
        <div className="admin-paper__header">
          <h3>All Shows</h3>
          <button onClick={this.toggleAddShowModal} className="admin__add-button">
            <Icon icon="Plus" /> Add Show
          </button>
        </div>
        <div className="admin-paper__content">
          <div className="card__wrapper">
            {shows.get('data').size ? (
              shows.get('data').map(show => (
                <Link to={`/tv/shows/${show.get('id')}`} className="show__card" key={`tv-show-${show.get('id')}`}>
                  {show.get('image_id') ? (
                    <div
                      className="show__card-image"
                      style={{ backgroundImage: `url(${show.getIn(['image', 'location'])})` }}
                    />
                  ) : (
                    <div className="show__card-image image__placeholder">No Image</div>
                  )}
                  <h4>{show.get('name')}</h4>
                  <span className="button button--full-width">Edit Show</span>
                </Link>
              ))
            ) : (
              <div className="admin-paper__no-content">There are currently no shows</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  shows: state.tv.shows,
}))(TvShowListPage);



// WEBPACK FOOTER //
// ./src/tv/shows/TvShowListPage.js